import { Skeleton, Box } from '@mui/joy';

const LoadingSkeleton = ({ 
  variant = 'rectangular', 
  width, 
  height, 
  count = 1,
  spacing = 1
}) => {
  const skeletons = Array.from({ length: count }, (_, index) => (
    <Skeleton
      key={index}
      variant={variant}
      width={width}
      height={height}
      sx={{
        bgcolor: 'success.50',
        '&::after': {
          background: 'linear-gradient(90deg, transparent, success.100, transparent)',
        },
        borderRadius: 'sm',
      }}
    />
  ));

  if (count === 1) {
    return skeletons[0];
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: spacing }}>
      {skeletons}
    </Box>
  );
};

export const TableSkeleton = ({ rows = 5, columns = 4 }) => (
  <Box sx={{ width: '100%' }}>
    {/* Header skeleton */}
    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
      {Array.from({ length: columns }, (_, i) => (
        <LoadingSkeleton key={i} height="40px" width="100%" />
      ))}
    </Box>
    
    {/* Row skeletons */}
    {Array.from({ length: rows }, (_, rowIndex) => (
      <Box key={rowIndex} sx={{ display: 'flex', gap: 2, mb: 1.5 }}>
        {Array.from({ length: columns }, (_, colIndex) => (
          <LoadingSkeleton key={colIndex} height="32px" width="100%" />
        ))}
      </Box>
    ))}
  </Box>
);

export const CardSkeleton = () => (
  <Box
    sx={{
      p: 3,
      border: '1px solid',
      borderColor: 'neutral.200',
      borderRadius: 'md',
      bgcolor: 'background.surface',
    }}
  >
    <LoadingSkeleton height="24px" width="60%" />
    <LoadingSkeleton height="40px" width="40%" sx={{ mt: 2 }} />
    <LoadingSkeleton height="16px" width="80%" sx={{ mt: 2 }} />
    <LoadingSkeleton height="16px" width="70%" sx={{ mt: 1 }} />
  </Box>
);

export default LoadingSkeleton;